<template>
  <BarChartWithLabel v-bind:title="title" v-bind:data="data" v-bind:labels="labels" />
</template>

<script>
import BarChartWithLabel from "@/components/management/statistics/common/BarChartWithLabel";
import { getAccessByPreferenceDeviceChartData } from "@/api/statisticsV2";

export default {
  components: {
    BarChartWithLabel,
  },
  data() {
    return {
      title: "Access by Preference Device",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByPreferenceDeviceChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.data;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
